import i18n from '@swa-ui/locale';
import { yup } from '@swa-ui/object';

export const fieldMaxLengths = {
    confirmationNumber: 6,
    firstName: 30,
    lastName: 30
};

export const fieldMinLengths = {
    confirmationNumber: 6
};

export const getAirSeatSchema = () =>
    yup
        .object()
        .shape({
            first_name: yup
                .string()
                .trim()
                .required()
                .matches(/^[a-zA-Z ]+$/)
                .label(i18n('SCHEMA__FIRST_NAME').toLowerCase()),
            last_name: yup
                .string()
                .trim()
                .required()
                .matches(/^[a-zA-Z ]+$/)
                .label(i18n('SCHEMA__LAST_NAME').toLowerCase()),
            record_locator: yup
                .string()
                .trim()
                .uppercase()
                .matches(/^[A-Z0-9]+$/)
                .max(fieldMaxLengths.confirmationNumber)
                .min(fieldMinLengths.confirmationNumber)
                .label(i18n('SCHEMA__CONFIRMATION_NUMBER').toLowerCase())
        })
        .noUnknown();